package com.iregained.site.components.sections.contact.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val ContactPatientContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White) // Contrasts with the gray B2B section
}

val PatientFormCardStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1000.px) // Narrower than the B2B split-screen for a focused reading experience
        .backgroundColor(Colors.White).borderRadius(16.px).padding(40.px)
        .boxShadow(0.px, 20.px, 40.px, color = Colors.Black.copy(alpha = 8))
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().custom.lightGray).margin(top = 40.px)
}

val PatientFormRowStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex).gap(24.px).margin(bottom = 24.px)
}

val PatientFormColumnStyle = CssStyle.base {
    Modifier.flex(1).display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
}

val PatientFormLabelStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(0.95.cssRem).fontWeight(FontWeight.SemiBold)
        .margin(bottom = 8.px)
}

val PatientFormInputStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(leftRight = 16.px, topBottom = 14.px)
            .borderRadius(8.px)
            .border(1.px, LineStyle.Solid, Colors.DarkGray)
            .backgroundColor(Colors.White)
            .fontSize(1.cssRem)
            .fontFamily("inherit")
            .color(colorMode.toSitePalette().custom.darkText)
            .transition(Transition.of("border-color", 200.ms))
    }
    focus {
        Modifier.border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary).outline(0.px)
    }
}

val PatientFormTextAreaStyle = CssStyle.base {
    Modifier.minHeight(120.px).resize(Resize.Vertical)
}

val PatientSubmitButtonStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().brand.primary).color(Colors.White)
            .fontSize(1.1.cssRem).fontWeight(FontWeight.SemiBold).padding(topBottom = 16.px).borderRadius(8.px)
            .border(0.px).cursor(Cursor.Pointer).transition(Transition.of("background-color", 200.ms))
    }
    hover {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.primaryHover)
    }
}